import { render, staticRenderFns } from "./knowledgebase.vue?vue&type=template&id=20e7c862&"
import script from "./knowledgebase.vue?vue&type=script&lang=js&"
export * from "./knowledgebase.vue?vue&type=script&lang=js&"
import style0 from "./knowledgebase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports